<form #form="ngForm"
      id="macro-editor-form"
      apFormFocus>
  <div id="{{Id}}">
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label class="label"
                 for="{{Id}}-name"
                 translate>Name</label>
          <input type="text"
                 class="form-control"
                 id="{{Id}}-name"
                 name="name"
                 [(ngModel)]="macroDefinitionDto.Name"
                 [apRequired]="true">
        </div>
      </div>
      <div class="col-md-8">
        <div class="form-group">
          <label class="label"
                 for="{{Id}}-description"
                 translate>Description</label>
          <textarea class="form-control macro-edit-textarea"
                    id="{{Id}}-description"
                    name="description"
                    [(ngModel)]="macroDefinitionDto.Description"
                    rows="3"
                    [apRequired]="true">
          </textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4">
        <p>Parameters:</p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <label for="{{Id}}-text">Text</label>
          <textarea name="text"
                    class="form-control macro-edit-textarea"
                    id="{{Id}}-text"
                    [(ngModel)]="macroDefinitionDto.Text"
                    rows="3"
                    [apRequired]="true">
          </textarea>
        </div>
      </div>
    </div>
    <span *ngIf="!disableVisitFields && !disablePatientFields">
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label class="label"
                   translate>SO Code</label>
            <ap-findcontrol [baseId]="Id + '-socode'"
                            [findControlId]="findControlIdService.SO_DST"
                            [(selectedPks)]="socodes"
                            [placeHolder]=""
                            (selectedPksChange)="onSOSelected($event)"
                            [singleSelect]="false"
                            [disabled]="disableVisitFields || disablePatientFields">
            </ap-findcontrol>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="label"
                   translate>SP Code</label>
            <ap-findcontrol [baseId]="Id + '-spcode'"
                            [findControlId]="findControlIdService.SP_DST"
                            [(selectedPks)]="spcodes"
                            [placeHolder]=""
                            (selectedPksChange)="onSPSelected($event)"
                            [singleSelect]="false"
                            [disabled]="disableVisitFields || disablePatientFields">
            </ap-findcontrol>
          </div>
        </div>
      </div>
    </span>
    <span *ngIf="!disableVisitFields && !disablePatientFields">
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label class="label"
                   translate>DX Code</label>
            <ap-dx-findcontrol2 name="dx-code"
                                [placeHolder]=""
                                (ngModelChange)="onDXChipsChanged($event)"
                                [singleSelect]="!allowDxMultiSelect"
                                [(ngModel)]="macroDiagnosis"
                                [disabled]="disableVisitFields || disablePatientFields">
            </ap-dx-findcontrol2>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="label"
                   for="{{Id}}-goal"
                   translate>Goal</label>
            <textarea [ngClass]="hasGoalError() ? 'ap-field-invalid-submitted' : ''"
                      class="form-control macro-edit-textarea"
                      id="{{Id}}-goal"
                      [disabled]="!goalEnabled || disablePatientFields"
                      name="goal"
                      [(ngModel)]="macroDefinitionDto.Goal"
                      rows="3"
                      #goalTextArea>
          </textarea>
            <div class="incorrect-input"
                 *ngIf="hasGoalError()">
              <sup></sup>{{goalError}}
            </div>
          </div>
        </div>
      </div>
    </span>
    <div class="row">
      <div class="col-sm-12">
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label class="label"
                 for="{{Id}}-group"
                 translate>Macro Group</label>
          <ap-findcontrol [baseId]="Id + '-group'"
                          [findControlId]="findControlIdService.ListMacroGroup"
                          [(selectedPks)]="groups"
                          [placeHolder]="'Select a Group'"
                          [requiredSearchParameters]="findControlSearchParams"
                          (chipChange)="onChipSelected($event)"
                          [required]="true"
                          [form]="form"
                          [singleSelect]="true">
          </ap-findcontrol>
        </div>
      </div>
      <span *ngIf="showPatientRequiredCheckbox">
        <div class="col-md-6">
          <div class="form-group">
            <div class="checkbox-container">
              <div class="checkboxes">
                <mat-checkbox id="{{Id}}-patient-required-macro"
                              [disableRipple]="true"
                              [(ngModel)]="patientRequired"
                              [disabled]="patientRequiredDisabled"
                              (change)="onCheckboxChanged()"
                              [ngModelOptions]="{standalone: true}"
                              translate>Patient Required</mat-checkbox>
              </div>
            </div>
          </div>
        </div>
      </span>
    </div>
  </div>
</form>
